var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Bitcoin1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 29.3333C23.3634 29.3333 29.3334 23.3633 29.3334 16C29.3334 8.63663 23.3634 2.66663 16.0001 2.66663C8.63675 2.66663 2.66675 8.63663 2.66675 16C2.66675 23.3646 8.63541 29.3333 16.0001 29.3333Z",
    fill: "#FC9F35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.3334C22 11.5947 20.8853 10.1127 19.3333 9.56204V7.33337H16.6667V9.33337H14.6667V7.33337H12V9.33337H10V12H12V20H10V22.6667H12V24.6667H14.6667V22.6667H16.6667V24.6667H19.3333V22.438C20.8853 21.888 22 20.4054 22 18.6667C22 17.6434 21.6133 16.708 20.9787 16C21.6133 15.292 22 14.3567 22 13.3334ZM14.6667 12H18C18.7353 12 19.3333 12.598 19.3333 13.3334C19.3333 14.0687 18.7353 14.6667 18 14.6667H14.6667V12ZM18 20H14.6667V17.3334H18C18.7353 17.3334 19.3333 17.9314 19.3333 18.6667C19.3333 19.402 18.7353 20 18 20Z",
    fill: "#FAE56B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 9.33337H12V12H14.6667V9.33337Z",
    fill: "#FFECAA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 20H12V22.6667H14.6667V20Z",
    fill: "#FFECAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Bitcoin1);
export default __webpack_public_path__ + "static/media/icons8-bitcoin-1.b76c23188c0168c3d1cffcbf0d95b264.svg";
export { ForwardRef as ReactComponent };